// extracted by mini-css-extract-plugin
export default {"dataObjectCard":"data-object-card_dataObjectCard__BHEjL"};